export default [
    {
        id: 1,
        name: 'Utilidad neta',
        formula: '(evalResult = this.form.er.net_profit)',
        info:'Utilidad operativa',
    },
    {
        id: 2,
        name: 'Participación neg./consumo fam.',
        formula: 'if (this.form.if.incomes.business_income != this.form.if.incomes.total) { evalResult = (this.form.if.incomes.business_income / this.form.if.incomes.total) * this.form.if.expenses.total } else { evalResult = this.form.if.expenses.total }',
        info:'Las variables son: Ingresos del negocio (Familiares) , Total ingresos familiares y Total de egresos de la unidad familiar',
    },
    {
        id: 3,
        name: 'Liquidez disponible',
        formula: 'var flag = 0; if (this.form.if.incomes.business_income != this.form.if.incomes.total) { flag = (this.form.if.incomes.business_income / this.form.if.incomes.total) * this.form.if.expenses.total } else { flag = this.form.if.expenses.total }; evalResult = this.form.er.net_profit - flag;',
        info:'Utilidad neta - Participación neg./consumo fam.',
    },
    {
        id: 4,
        name: 'Capacidad de pago (60%)',
        formula: 'var flag = 0; if (this.form.if.incomes.business_income != this.form.if.incomes.total) { flag = (this.form.if.incomes.business_income / this.form.if.incomes.total) * this.form.if.expenses.total } else { flag = this.form.if.expenses.total }; evalResult = (this.form.er.net_profit - flag)*0.6;',
        info:'(Utilidad neta - Participación neg./consumo fam.) * 0.6',
    },
]
